import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["clip", "content", "toggle", "fade", "readMore", "readLess"];

  connect() {
    this.isExpanded = false;
    this.setTextColor(false);

    requestAnimationFrame(() => this.checkContentHeight());

    if (document.fonts?.ready) {
      document.fonts.ready.then(() => {
        if (!this.isExpanded) this.checkContentHeight();
      });
    }
  }

  checkContentHeight() {
    if (!this.hasClipTarget || !this.hasContentTarget || !this.hasToggleTarget) {
      return;
    }
    if (this.isExpanded) return;
    if (this.clipTarget.classList.contains("is-collapsed")) return;

    if (this.contentTarget.scrollHeight > this.collapsedHeight()) {
      this.clipTarget.classList.add("is-collapsed");
      this.showFade();
      this.toggleTarget.style.display = "block";
    } else {
      this.toggleTarget.style.display = "none";
    }
  }

  toggle() {
    if (this.isExpanded) {
      this.collapse();
    } else {
      this.expand();
    }
  }

  collapse() {
    this.clipTarget.classList.add("is-collapsed");
    this.showFade();
    this.showReadMore();
    this.isExpanded = false;
    this.setTextColor(false);
  }

  expand() {
    this.clipTarget.classList.remove("is-collapsed");
    this.hideFade();
    this.showReadLess();
    this.isExpanded = true;
    this.setTextColor(true);
  }

  collapsedHeight() {
    const value = getComputedStyle(this.clipTarget).getPropertyValue(
      "--announcement-collapsed-height"
    );
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 160;
  }

  showFade() {
    if (this.hasFadeTarget) this.fadeTarget.classList.remove("hidden");
  }

  hideFade() {
    if (this.hasFadeTarget) this.fadeTarget.classList.add("hidden");
  }

  showReadMore() {
    if (this.hasReadMoreTarget) this.readMoreTarget.style.display = "inline";
    if (this.hasReadLessTarget) this.readLessTarget.style.display = "none";
    if (this.hasToggleTarget) this.toggleTarget.setAttribute("aria-expanded", "false");
  }

  showReadLess() {
    if (this.hasReadMoreTarget) this.readMoreTarget.style.display = "none";
    if (this.hasReadLessTarget) this.readLessTarget.style.display = "inline";
    if (this.hasToggleTarget) this.toggleTarget.setAttribute("aria-expanded", "true");
  }

  setTextColor(isExpanded) {
    if (!this.hasContentTarget) return;
    this.contentTarget.classList.toggle("text-gray-900", isExpanded);
    this.contentTarget.classList.toggle("text-gray-500", !isExpanded);
  }
}
